import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { TranslateService } from "../../services/translate/translate.service";
import { GroupsUsersService } from "../../services/groups/groups-users.service";

@Component({
  selector: "mg-modal-groups-users",
  templateUrl: "./modal-groups-users.component.html",
  styleUrls: ["./modal-groups-users.component.scss"],
})
export class ModalGroupsUsersComponent implements OnInit, OnDestroy {
  isDragActive = false;
  fileUrl = "";
  nameClient = "";
  subscriptionTranslate!: Subscription;
  dataTranslateModalUserGroups!: any;
  constructor(
    public dialogRef: MatDialogRef<ModalGroupsUsersComponent>,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.getTranslate();
  }

  urlUploadedHandle({ url }: { url: string }) {
    this.fileUrl = url;
  }

  urlUploadedErrorHandle(error: string) {
    console.error(error);
  }

  public onDragOver() {
    this.isDragActive = true;
  }

  public onDragLeave(event: Event) {
    this.isDragActive = false;
  }

  save() {
    this.dialogRef.close({ resp: true, name: this.nameClient, file: this.fileUrl });
  }
  close(resp: boolean) {
    this.dialogRef.close({ resp });
  }

  getTranslate() {
    this.subscriptionTranslate = this.translate.init("core").subscribe((data) => {
      this.dataTranslateModalUserGroups = data.userGroups.modalNew;
    });
  }

  ngOnDestroy(): void {
    this.subscriptionTranslate?.unsubscribe();
  }
}
